import React from 'react'
import * as styles from './IncommRetailerCashierInstructions.module.scss'

interface IncommRetailerCashierInstructionsProps {
  title: string
  description: string
}

export const IncommRetailerCashierInstructions = ({
  title,
  description,
}: IncommRetailerCashierInstructionsProps) => {
  return (
    <div className={styles.incommRetailerCashierInstructions}>
      <div dangerouslySetInnerHTML={{
        __html: title
      }} className={styles.incommRetailerCashierInstructionsTitle}/>
      <div
        dangerouslySetInnerHTML={{ __html: description }}
        className={styles.incommRetailerCashierInstructionsDescription}
      />
    </div>
  )
}
